import React, { CSSProperties, useState, useEffect } from "react";
import Layout from "../../Layout";
import CatalogsLayout from "Components/CatalogsLayout";
import Grid, {
  TextFilter,
  SelectColumnFilter,
  NumberFilter,
} from "Components/Grid";
import GridModal from "Components/GridModal";
import Buttons from "../../Components/Buttons";
import { useSelector } from "react-redux";
import {
  addProfile,
  deleteProfile,
  getProfiles,
  updateProfile,
} from "actions/perfil";
import { IProfile } from "Interfaces/IProfile";
import ConfirmationModal from "Components/ConfirmationModal";
import { validateForm } from "../../utils";
import FormPerfil from "Forms/Perfil";
import TabsModal, { TabModalPanel } from "Components/TabsModal";

const Perfil = () => {
  const defaultItem = {
    idPerfil: 0,
    descripcion: "",
    relPerfilVistas: [],
    relPerfilTiposOperacion: [],
    idEstatus: 1,
  };

  const [title] = useState("Perfiles");
  const [openTabs, setOpenTabs] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [profiles, setProfiles] = useState<any>();
  const [views, setViews] = useState<any>([]);
  const [reports, setReports] = useState<any>([]);
  const [operationTypes, setOperationTypes] = useState<any>([]);
  const [errors, setErrors] = useState<IProfile>({});
  const [formValues, setFormValues] = useState<any>({});
  const [formValuesList, setFormValuesList] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(true);
  const [tabs, setTabs] = useState<any>();
  const [closed, setClosed] = React.useState<boolean>(false);
  const [pageIndexView, setPageIndexView] = useState<number>(0);
  const [pageIndexReport, setPageIndexReport] = useState<number>(0);
  const [pageIndexOperationType, setPageIndexOperationType] = useState<number>(0);
  const [selectedTab, setSelectedTab] = React.useState(0);
  const viewReportData = useSelector((state: any) => state.viewReportData);
  const operationTypeData = useSelector(
    (state: any) => state.operationTypeData
  );

  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);

  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const loadProfiles = () => {
    getProfiles(0).then((res) => {
      if (res) setProfiles(res);
      setIsLoadingGrid(false);
    });
  };

  useEffect(() => {
    loadProfiles();
  }, []);

  useEffect(()=>{
    console.log(views)
  },[views])

  useEffect(() => { }, [formValues, formValuesList])

  const loadTabs = () => {
    setTabs([
      { id: 0, name: "Perfiles" },
      { id: 1, name: "Vistas" },
      { id: 2, name: "Reportes" },
      { id: 3, name: "Marca y Tipo de Operación" },
    ]);
  };

  const handleAddClick = () => {
    loadTabs();
    setAction("add");
    setErrors({});
    setFormValues(defaultItem);
    setFormValuesList(defaultItem);
    setSelectedViews(defaultItem);
    setPageIndexView(0);
    setPageIndexReport(0);
    setPageIndexOperationType(0);
    setSelectedTab(0);
    setOpenTabs(true);
  };

  const handleActionClick = (e: any, action: string) => {
    switch (action) {
      case "view":
        handleView(e);
        break;
      case "edit":
        handleEdit(e);
        break;
      case "status":
        handleStatus(e);
        break;
    }
  };

  const handleView = (item: any) => {
    setFormValues(item);
    setFormValuesList(item);
    setAction("view");
    setOpenTabs(true);
  };

  const handleEdit = (item: any) => {
    getProfiles(item.idPerfil).then((res) => {
      if (res && res.length > 0) {
        loadTabs();
        setAction("edit");
        setErrors({});
        setFormValues(res[0]);
        setFormValuesList(res[0]);
        setSelectedViews(res[0]);
        setPageIndexView(0);
        setPageIndexReport(0);
        setPageIndexOperationType(0);
        setSelectedTab(0);
        setOpenTabs(true);
      }
    });
  };

  const handleStatus = (item: any) => {
    getProfiles(item.idPerfil).then((res) => {
      if (res && res.length > 0) {
        res[0].idEstatus = res[0].idEstatus === 1 ? 0 : 1;
        setFormValues(res[0]);
        setOpenConfirm(true);
      }
    });
  };

  const handleConfirm = () => {
    setIsLoading(true)
    updateProfile(formValues.idPerfil, formValues).then((res) => {
      if (res) {
        loadProfiles();
        setOpenConfirm(false);
      }
      setIsLoading(false);
    });
  };

  const handleCancelConfirm = () => {
    setOpenConfirm(false);
    setFormValues(defaultItem);
    setFormValuesList(defaultItem);
    loadProfiles();
  };

  const setSelectedViews = async (item: any) => {
    let tempViews = viewReportData.viewList?.map((view: any) => {
      return { ...view, selected: false };
    });

    console.log(tempViews);
    
    let tempReports = viewReportData.reportList?.map((report: any) => {
      return { ...report, selected: false };
    });
    const viewsList = tempViews?.map((view: any) => {
      let selected = view.selected;
      item.relPerfilVistas.forEach((rel: any) => {
        if (view.idVista === rel.idVista && rel.delete === false) {
          selected = true;
        }
      })
      return { ...view, selected: selected }
    })
    setViews(viewsList.filter((view: any) => view.idTipoVista === 3))
    const reportList = tempReports?.map((report: any) => {
      let selected = report.selected;
      item.relPerfilVistas.forEach((rel: any) => {
        if (report.idVista === rel.idVista && rel.delete === false) {
          selected = true;
        }
      });
      return { ...report, selected: selected };
    });
    setReports(reportList);
    let tempOperationTypes = operationTypeData.operationTypeList?.map(
      (operationType: any) => {
        return { ...operationType, selected: false };
      }
    );
    const operationTypesList = tempOperationTypes?.map((operationType: any) => {
      let selected = operationType.selected;
      item.relPerfilTiposOperacion.forEach((rel: any) => {
        if (
          operationType.idTipoOperacion === rel.idTipoOperacion &&
          rel.delete === false
        ) {
          selected = true;
        }
      });
      return { ...operationType, selected: selected };
    });
    setOperationTypes(operationTypesList);
  };

  const handleOnChange = (e: any) => {
    let value = e.target.value;
    let id = e.target.id;

    let itemError: any = errors;
    delete itemError[id];
    setErrors(itemError);

    if (id === "descripcion") {
      if (value !== "") {
        let res = /^[\w\s]+$/.test(e.target.value)
        if (!res) {
          value = formValues[id]
        }
      }
    }

    setFormValues({
      ...formValues,
      [id]: value,
    });
  };

  const handleCheckedChange = async (e: any) => {
    let tempItem = formValuesList
    if (e.gridId === "1" || e.gridId === "2") {
      tempItem = await applySelectViewReport(tempItem, e)
      if (e.idVistaPadre !== 0) {
        let tempViews = viewReportData.viewList
        let tempParent1 = tempViews.find((parent1: any) => parent1.idVista === e.idVistaPadre)
        if (tempParent1) {
          tempParent1.selected = e.selected
          tempItem = await applySelectViewReport(tempItem, tempParent1)
        }
        if (tempParent1.idVistaPadre !== 0) {
          let tempViews = viewReportData.viewList
          let tempParent2 = tempViews.find((parent2: any) => parent2.idVista === tempParent1.idVistaPadre)
          if (tempParent2) {
            tempParent2.selected = e.selected
            tempItem = await applySelectViewReport(tempItem, tempParent2)
          }
        }
      }
    }
    if (e.gridId === "3") {
      tempItem = await applySelectOperationType(tempItem, e)
    }
    setFormValuesList(tempItem)
    setSelectedViews(tempItem)
  }

  const applySelectViewReport = async (tempItem: any, e: any) => {
    let tempViews = viewReportData.viewList
    if (e.selected) {
      let hasChilds = await findChilds(e.idVista, tempItem.relPerfilVistas, tempViews)
      tempItem.relPerfilVistas.forEach((rel: any) => {
        if (e.idVista === rel.idVista && !hasChilds) {
          rel.delete = true
        }
      })
    } else {
      let inList = false
      tempItem.relPerfilVistas.forEach((rel: any) => {
        if (e.idVista === rel.idVista) {
          rel.delete = false
          inList = true
        }
      })
      if (!inList) {
        tempItem.relPerfilVistas.push({
          idPerfil: tempItem.idPerfil,
          idVista: e.idVista,
          idVistaPadre: e.idVistaPadre,
          saved: false,
          delete: false,
        })
      }
    }
    return tempItem
  }

  const applySelectOperationType = async (tempItem: any, e: any) => {
    if (e.selected) {
      tempItem.relPerfilTiposOperacion.forEach((rel: any) => {
        if (e.idTipoOperacion === rel.idTipoOperacion) {
          rel.delete = true
        }
      })
    } else {
      let inList = false
      tempItem.relPerfilTiposOperacion.forEach((rel: any) => {
        if (e.idTipoOperacion === rel.idTipoOperacion) {
          rel.delete = false
          inList = true
        }
      })
      if (!inList) {
        tempItem.relPerfilTiposOperacion.push({
          idPerfil: tempItem.idPerfil,
          idTipoOperacion: e.idTipoOperacion,
          saved: false,
          delete: false,
        })
      }
    }
    return tempItem
  }

  const findChilds = async (idParent: any, selectedList: any, viewList: any) => {
    let hasChilds = false
    if (idParent !== 0) {
      viewList.filter((item: any) => item.idVistaPadre === idParent).forEach((view: any) => {
        selectedList.forEach((element: any) => {
          if (view.idVista === element.idVista && element.delete === false) {
            hasChilds = true
          }
        })
      })
    }
    return hasChilds
  }

  const handleTabChangeClick = (event: any, newTab: any) => {
    setSelectedTab(newTab);
  };

  const handleNextClick = () => {
    if (!handleValidation()) {
      return false;
    }
    setSelectedTab(selectedTab + 1);
  };

  const handleAccept = () => {
    if (!handleValidation()) {
      setSelectedTab(0);
      return false;
    }
    setIsLoading(true);
    formValues.relPerfilVistas = formValuesList.relPerfilVistas;
    formValues.relPerfilTiposOperacion = formValuesList.relPerfilTiposOperacion;
    if (action === "add") {
      addProfile(formValues).then((res) => {
        if (res) {
          loadProfiles();
          setOpenTabs(false);
          setFormValues({});
          setFormValuesList({});
        }
        setIsLoading(false);
      });
    }
    if (action === "edit") {
      updateProfile(formValues.idPerfil, formValues).then((res) => {
        if (res) {
          loadProfiles();
          setOpenTabs(false);
          setFormValues({});
          setFormValuesList({});
        }
        setIsLoading(false);
      });
    }
  };

  const handleValidation = () => {
    let isValid = validateForm({
      schema: {
        descripcion: { message: "Ingrese el nombre" },
      },
      values: formValues,
    });
    if (Object.keys(isValid).length) {
      setErrors({ ...isValid });
      return false;
    }
    return true;
  };

  const handleCancel = () => {
    setOpenTabs(false);
    loadProfiles();
    setClosed(false);
  };

  const columns = [
    {
      accessor: "descripcion",
      Header: "Nombre",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "estatus",
      Header: "Estatus",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
  ];

  const config: any = {
    actions: [
      {
        action: "view",
        tooltip: "Detalles",
        visible: false,
        color: "#0079ab",
        icon: "search",
      },
      {
        action: "edit",
        tooltip: "Editar",
        visible: true,
        color: "#ffb300",
        icon: "edit",
      },
      {
        action: "status",
        tooltip: "Estatus",
        visible: true,
        color: "#00a176",
        icon: "check",
        isStatus: "idEstatus",
        colorNegative: "#f15642",
        iconNegative: "clear",
      },
    ],
  };

  const getModalColumns = (id: string) => {
    const modalColumns: any = [];
    switch (id) {
      case "1":
        modalColumns.push({
          accessor: "vistaPadre",
          Header: "Menú",
        });
        modalColumns.push({
          accessor: "descripcion",
          Header: "Vista",
        });
        break;
      case "2":
        modalColumns.push({
          accessor: "vistaPadre",
          Header: "Menú",
        });
        modalColumns.push({
          accessor: "descripcion",
          Header: "Reporte",
        });
        break;
      case "3":
        modalColumns.push({
          accessor: "marca",
          Header: "Marca",
        });
        modalColumns.push({
          accessor: "tipoOperacion",
          Header: "Tipo de operación",
        });
        break;
    }

    return modalColumns;
  };

  const getModalConfig = (id: string) => {
    let modalConfig: any = {};

    let modalSelects: any = [
      {
        action: "status",
        Header: "Estatus",
        valueSelect: "selected",
        visible: true,
        accessor: "estatus",
      },
    ];

    let modalActions: any = [];

    modalConfig.gridId = id;
    modalConfig.selects = modalSelects;
    modalConfig.actions = modalActions;
    return modalConfig;
  };

  const handlePageChange = (e: any) => {
    switch (e.gridId) {
      case "1":
        setPageIndexView(pageIndexView + e.page);
        break;
      case "2":
        setPageIndexReport(pageIndexReport + e.page);
        break;
      case "3":
        setPageIndexOperationType(pageIndexOperationType + e.page);
        break;
    }
  };

  return (
    <Layout theme={styles}>
      <>
        <CatalogsLayout bannerTitle={title}>
          <>
            <Grid
              columns={columns}
              data={profiles || []}
              config={config}
              isLoading={isLoadingGrid}
              handleActionClick={handleActionClick}
            >
              <Buttons
                title={"Nuevo Perfil"}
                type={"add-catalog"}
                config={btnSimple}
                handleClick={handleAddClick}
              />
            </Grid>
            {openTabs && (
              <TabsModal
                open={openTabs}
                tabs={tabs}
                selectedTab={selectedTab}
                lastTab={3}
                modalSize={"lg"}
                isLoading={isLoading}
                handleTabChangeClick={handleTabChangeClick}
                handleNextClick={handleNextClick}
                handleAcceptClick={handleAccept}
                handleCancelClick={() => {
                  setClosed(true);
                }}
              >
                <>
                  <TabModalPanel tabId={0} selectedTab={selectedTab}>
                    <FormPerfil
                      item={formValues}
                      action={action}
                      errors={errors}
                      handleOnChange={handleOnChange}
                    />
                  </TabModalPanel>
                  <TabModalPanel tabId={1} selectedTab={selectedTab}>
                    <>
                      <GridModal
                        columns={getModalColumns("1")}
                        data={views || []}
                        config={getModalConfig("1")}
                        handleCheckedChange={handleCheckedChange}
                        pageStateIndex={pageIndexView}
                        handlePageChange={handlePageChange}
                      />
                    </>
                  </TabModalPanel>
                  <TabModalPanel tabId={2} selectedTab={selectedTab}>
                    <>
                      <GridModal
                        columns={getModalColumns("2")}
                        data={reports || []}
                        config={getModalConfig("2")}
                        handleCheckedChange={handleCheckedChange}
                        pageStateIndex={pageIndexReport}
                        handlePageChange={handlePageChange}
                      />
                    </>
                  </TabModalPanel>
                  <TabModalPanel tabId={3} selectedTab={selectedTab}>
                    <>
                      <GridModal
                        columns={getModalColumns("3")}
                        data={operationTypes || []}
                        config={getModalConfig("3")}
                        handleCheckedChange={handleCheckedChange}
                        pageStateIndex={pageIndexOperationType}
                        handlePageChange={handlePageChange}
                      />
                    </>
                  </TabModalPanel>
                </>
              </TabsModal>
            )}
            {openConfirm && (
              <ConfirmationModal
                open={openConfirm}
                description={`¿Está seguro de ${formValues.idEstatus === 1 ? "activar" : "desactivar"
                  } el perfil ${formValues.descripcion}?`}
                modalSize={"sm"}
                isLoading={isLoading}
                handleConfirmClick={handleConfirm}
                handleCancelClick={handleCancelConfirm}
              ></ConfirmationModal>
            )}
            {closed && (
              <ConfirmationModal
                open={closed}
                description={`Se perderan todos los cambios realizados`}
                modalSize={"sm"}
                isLoading={isLoading}
                handleConfirmClick={handleCancel}
                handleCancelClick={() => {
                  setClosed(false);
                }}
              ></ConfirmationModal>
            )}
          </>
        </CatalogsLayout>
      </>
    </Layout>
  );
};

export default Perfil;
